import { useEventBus } from '@bus/useEventBus';

/**
 * Click-to-play embed for a vertical (9:16) YouTube Short — same pattern as
 * ChapterVideo: our own poster until the user taps play, then a
 * youtube-nocookie iframe. `playing` is controlled so a list can keep only
 * one video running at a time.
 */
export function ShortVideo({
  videoId, title, poster, playing, onPlay, eager = false,
}: {
  videoId: string;
  title: string;
  poster: string;
  playing: boolean;
  onPlay: () => void;
  eager?: boolean;
}) {
  const emit = useEventBus();

  function play() {
    onPlay();
    emit({ kind: 'dialogue.advance', payload: { simId: `video:excel:${videoId}`, step: 1, direction: 'next' } });
  }

  return (
    <div className="relative aspect-[9/16] w-full bg-ink-900 overflow-hidden rounded-[inherit]">
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0`}
          title={title}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button onClick={play} className="absolute inset-0 group" aria-label={`Play ${title}`}>
          <img
            src={poster}
            alt=""
            width={540}
            height={960}
            loading={eager ? 'eager' : 'lazy'}
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <span className="absolute inset-0 bg-gradient-to-t from-ink-900/50 via-transparent to-transparent" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/95 group-hover:bg-white text-ink-900 flex items-center justify-center ring-[6px] ring-white/20 shadow-[0_8px_28px_rgba(0,0,0,0.45)] transition-[transform,background-color] duration-200 group-hover:scale-105 motion-reduce:transition-none motion-reduce:group-hover:scale-100">
              <svg viewBox="0 0 24 24" className="w-6 h-6 ml-0.5 fill-current" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
